import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../servicios/auth.service';
import { EmpresaService } from 'src/app/admin/servicios/empresa.service';
import { GlobalServices } from 'src/app/admin/servicios/globales.services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  // Para poder setear el focus al tratar de entrar.
  @ViewChild('inputEmail') input_email!: ElementRef;
  @ViewChild('inputPassword') input_password!: ElementRef;

  @ViewChild('inputEmailReesPass') input_reesPass!: ElementRef;

  public loginForm: FormGroup; // Para logerarse
  public olvidePassForm: FormGroup; // Para enviar correo de reestablecer Pass
  public olvidePass: boolean = false;
  // Controlar errores del Form
  public errorForm!: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private empresaService: EmpresaService,
    private global: GlobalServices//Servicios globales
  ) {
    // Inicializando Form
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      pass: ['', Validators.required],
    });

    // Inicializando Form reestablece Password
    this.olvidePassForm = this.fb.group({
      correo: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit() {}

  // Enviar data del Form (login)
  async sendDataForm() {
    // Extrayendo la dat del formularion
    const valueForm = this.loginForm.value;

    const email = valueForm['email'];
    const pass = valueForm['pass'];

    // Validar Form
    if (this.loginForm.valid) {

      // objeto con data del User
      const sendData = {
        email,
        pass
      };

      // Limpiar Form
      this.errorForm = '';
      this.input_email.nativeElement.style.borderColor = "black";
      this.input_password.nativeElement.style.borderColor = "black";

      // Roles permitidos
      const superAdmin = "Super Administrador";
      const admin = "Administrador";
      const miembroAdmin = "Miembro (Admin)";
      const miembro = "Miembro";
      const verify = await this.empresaService.verifyLogin(sendData.email, superAdmin, admin, miembroAdmin, miembro);

      const { ok } = verify;


      if (ok) {
        // Si ambos campos están llenos, intentar loguearse.
        this.authService.doLogin(sendData).subscribe(() => {
          // Si el logueo es exitoso, mandar a publicaciones.
          this.router.navigate(['/AmChamAdmin']);

          this.empresaService.updateStatePass(email);
          // Manejo de errores.
        }, (err) => {
          if (err.code === 'auth/invalid-email') {
            err.message = 'Por favor, ingrese una direccion de correo válida';
          }
          if (err.code === 'auth/wrong-password') {
            err.message = 'La contraseña no es válida.';
          }
          if (err.code === 'auth/user-not-found') {
            err.message = 'No hay registro de este usuario';
          }
          if (err.code === 'auth/network-request-failed') {
            err.message = 'A ocurrido un error en la red';
          }
          if (err.code === '403') {
            err.message = 'Acceso denegado';
          }
          this.errorForm = err.message;
        });
      } else {
        //Si el email del form coincide con alguno de la coleccion empresa mostrar un modal
        this.global.ngModalAlert('error', 'Aviso de credenciales', 'Su usuario no posee acceso a esta platafoma');
      }



    } else {
      // Validar cual input esta vacio
      if (!email) {
        this.input_email.nativeElement.style.borderColor = "red";
        this.input_email.nativeElement.focus(); // Focus al input
      } else if (!pass) {
        this.input_password.nativeElement.style.borderColor = "red";
        this.input_password.nativeElement.focus(); // Focus al input
      }
      this.errorForm = 'Faltan campos por completar';
    }
  }

  olvidePassF() {

    // Extrayendo data de Form
    const valueForm = this.olvidePassForm.value;

    const email = valueForm['correo'];

    // Validar Form
    if (this.olvidePassForm.valid) {
      // Limpiar Form
      this.errorForm = '';
      this.input_reesPass.nativeElement.style.borderColor = "black";
      this.input_reesPass.nativeElement.style.borderColor = "black";

      // Send email
      this.authService.enviarCorreo(email).then(() => {
        this.global.ngModalAlert('success', 'Correo enviado', 'Por favor, verifique su correo electrónico', () => {
          // Cambiar estado variable
          this.olvidePass = false;
        });
      }).catch((error) => {
        if (error.code === 'auth/user-not-found') {
          this.global.ngModalAlert('error', 'Error', 'No hay registro de este usuario');
        } else {
          this.global.ngModalAlert('error', 'Error', error);
        }
      });



    } else {
      this.input_reesPass.nativeElement.style.borderColor = "red";
      this.input_reesPass.nativeElement.focus(); // Focus al input
      this.errorForm = 'Faltan campos por completar';
    }
  }

}
